import { useEffect, useRef } from 'react'

/**
 * Run `onRestore` when the browser shows this page again from its back/forward
 * cache — the user left for another site (Stripe's billing portal) and pressed
 * Back instead of following that site's own return link.
 *
 * A cached page comes back with its React state frozen as it was when the
 * browser left: a button that said "Opening…" still says it and stays
 * disabled, and data the other site may have changed is stale. A normal load
 * never fires this; only the restore does.
 */
export function usePageRestored(onRestore: () => void): void {
  const latest = useRef(onRestore)
  latest.current = onRestore

  useEffect(() => {
    const handle = (event: PageTransitionEvent) => {
      if (event.persisted) latest.current()
    }
    window.addEventListener('pageshow', handle)
    return () => window.removeEventListener('pageshow', handle)
  }, [])
}
